import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsRouteRenderingPaused, loginCustomerViaJWTToken } from "@nxplatform/customer-noauth/slices/customer-noauth.slice";
import { typedShallowEqual } from "@nxplatform/helpers/helpers";
import { getQueryParam } from "../query.hook.js";
const useJWTAuthorizationHook = () => {
  const dispatch = useDispatch();
  const {
    allowRouteRendering
  } = useSelector((state) => ({
    allowRouteRendering: !selectIsRouteRenderingPaused(state)
  }), typedShallowEqual);
  const jwtToken = getQueryParam().get("jwtToken");
  const bmToken = getQueryParam().get("bmToken");
  useEffect(() => {
    if (jwtToken) {
      dispatch(loginCustomerViaJWTToken({ jwtToken, bmToken }));
    }
  }, [jwtToken, bmToken]);
  return { allowRouteRendering };
};
export {
  useJWTAuthorizationHook
};
